import PropTypes from "prop-types";
import CountUp from "react-countup";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultCounterCard({ color, count, title, description, ...rest }) {
  return (
    <MKBox
      p={2}
      textAlign="center"
      lineHeight={1}
      sx={{
        width: { xs: "80%", sm: "90%", md: "100%" }, // 모바일에서 박스 너비 축소
        mx: "auto", // 가운데 정렬
        p: { xs: 1, sm: 2, md: 3 }, // 패딩 축소
        "@media (max-width: 600px)": {
          transform: "scale(0.9)", // 박스 자체를 축소
        },
      }}
    >
      <MKTypography
        variant="h1"
        color={color}
        textGradient
        sx={{
          fontSize: { xs: "1.25rem", sm: "2rem", md: "3rem" }, // 작은 화면에서는 숫자 글씨 더 작게
        }}
      >
        <CountUp end={count} duration={1} {...rest} />
      </MKTypography>
      {title && (
        <MKTypography
          variant="h5"
          mt={1}
          mb={1}
          sx={{
            fontSize: { xs: "0.75rem", sm: "1rem", md: "1.25rem" }, // 타이틀 글씨 더 작게
          }}
        >
          {title}
        </MKTypography>
      )}
      {description && (
        <MKTypography
          variant="body2"
          color="black"
          sx={{
            fontSize: { xs: "0.5rem", sm: "0.75rem", md: "1rem" },
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </MKTypography>
      )}
    </MKBox>
  );
}

// Setting default props for the DefaultCounterCard
DefaultCounterCard.defaultProps = {
  color: "info",
  description: "",
  title: "",
};

// Typechecking props for the DefaultCounterCard
DefaultCounterCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  count: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DefaultCounterCard;
